import { Component, OnInit } from '@angular/core';
import { SurveyService } from 'src/app/services/survey.service';

@Component({
  selector: 'app-negative-survey-feedback',
  templateUrl: './negative-survey-feedback.component.html',
  styleUrls: ['./negative-survey-feedback.component.scss'],
})
export class NegativeSurveyFeedbackComponent implements OnInit {

  constructor(public surveyServ: SurveyService) { }

  ngOnInit() { }

}
